import { createContext } from "preact";
import type { ComponentChildren } from "preact";
import { useContext } from "preact/hooks";
import type { SiteConfig } from "../../lib/gboModels";

const SiteConfigContext = createContext<SiteConfig | null>(null);

export function SiteConfigProvider({
  children,
  siteConfig,
}: {
  children: ComponentChildren;
  siteConfig: SiteConfig;
}) {
  return <SiteConfigContext.Provider value={siteConfig}>{children}</SiteConfigContext.Provider>;
}

export function useSiteConfig() {
  const siteConfig = useContext(SiteConfigContext);
  if (!siteConfig) throw new Error("Site config is not available in this page context.");

  return siteConfig;
}
